import { NodeType } from 'prosemirror-model'

import { CustomIcon, type CustomIconProps } from '../CustomIcon/CustomIcon'

interface ElementIconProps extends Omit<CustomIconProps, 'icon'> {
  node: NodeType
  active?: boolean
}

/**
 * Renders the icon associated with the given ProseMirror Node
 */
export function ElementIcon(props: ElementIconProps) {
  'use memo'

  const { node, ...rest } = props

  return <CustomIcon icon={iconName(props.node)} {...rest} />
}

// Most icons map nicely to the CustomIcon "icon-nodename" convention. For those
// that don't, map the node name to right string
const ELEMENTS: Record<string, `icon-${string}`> = {
  sceneHeading: 'icon-scene-heading',
  new_act: 'icon-new-act',
  end_of_act: 'icon-end-of-act',
}

function iconName(node: NodeType) {
  return ELEMENTS[node.name] ?? `icon-${node.name}`
}
